//TODO: refactor these components to use the Bay-ui or bootstrap components to shrink size
import { Tooltip } from '@blueprintjs/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import cloneDeep from 'lodash/cloneDeep';
import React, { useState, useEffect, useRef } from 'react';
import {
	Form,
	Dropdown,
	Button,
	Offcanvas,
	Modal,
	Collapse,
	InputGroup,
} from 'react-bootstrap';
import {
	BsGearFill,
	BsGrid1X2Fill,
	BsInfoCircle,
	BsEye,
	BsQuestionCircle,
	BsPencil,
	BsX,
	BsCheck,
	BsFillCaretDownFill,
	BsChatRightQuote,
} from 'react-icons/bs';

/* eslint-disable no-unused-vars */

import BayBadge from '../../BayBadge';
import BayCountryIcon from '../../BayCountryIcon';
import { dataFields } from '../../BayPolotnoEditor/dataFields';
import { sampleData } from '../../BayPolotnoEditor/sampleData';
import BaySelect from '../../BaySelect';
import BayTags from '../../BayTags';
import BayTooltip from '../../BayTooltip';
import SocialMediaCaptionDrawer from '../../DesignStudio/CaptionEditor';
import VariableDropdown from '../../DesignStudio/CaptionEditor/VariableDropdown';
import {
	isSocialPostTemplate,
	hasListingOverlayFlag,
	buildListingOverlayPreviewsFromRasters,
} from '../../utilities';
import { sections } from '../../utilities/constants';

import JsonViewer from './JsonViewer';

dayjs.extend(relativeTime);

const TextElementForm = ({
	formFields,
	fieldOptions,
	elementValue,
	handleChange,
	selectedElementObject,
	handleVariableInsert,
	t,
}) => {
	const getOptionValue = (array, string) => {
		const returnVal = array.find((option) => option.value === string);
		return returnVal ? returnVal : null;
	};

	return (
		<div className="row mb-6 ms-1">
			<div className="col">
				<Form.Group className="mb-3" id="variablesForm-color-group">
					<Form.Label>{t('fontColor')}</Form.Label>
					<BaySelect
						controlledValue={
							getOptionValue(fieldOptions('userBrand'), formFields.color) ||
							(formFields.color
								? { value: formFields.color, label: 'Current Color' }
								: null)
						}
						id="variablesForm-color"
						optionsArray={[
							{ value: selectedElementObject.fill, label: 'Current Color' },
							...fieldOptions('userBrand').map((option) => option),
						]}
						onChangeFunc={(value) => handleChange(value, 'color')}
					/>
				</Form.Group>

				<Form.Group className="mb-3" id="variablesForm-format-group">
					<Form.Label>
						<span className="me-2">{t('textFormat')}</span>
						<BayTooltip overlay={t('textFormatTooltip')} placement="top">
							<BsQuestionCircle />
						</BayTooltip>
					</Form.Label>

					<BaySelect
						controlledValue={getOptionValue(
							fieldOptions('format'),
							formFields.format,
						)}
						id="variablesForm-format"
						optionsArray={[
							{ value: 'string', label: 'Plain Text' },
							...fieldOptions('format').map((option) => option),
						]}
						onChangeFunc={(value) => handleChange(value, 'format')}
					/>
				</Form.Group>

				<Form.Group className="mb-3" id="variablesForm-format-group">
					<Form.Label>
						<span className="me-2">{t('maxTextCount')}</span>
						<BayTooltip overlay={t('maxCountTooltip')} placement="top">
							<BsQuestionCircle />
						</BayTooltip>
					</Form.Label>

					<Form.Control
						disabled={formFields.format !== 'string'}
						id="variablesForm-maxLen"
						name="maxLen"
						step={1}
						type="number"
						value={formFields.format !== 'string' ? 0 : formFields.maxLen}
						onChange={(elm) => handleChange(elm, 'maxLen')}
					/>

					<Form.Text className="text-400">
						<em>
							({t('currentCount')}: {elementValue?.length})
						</em>
					</Form.Text>
				</Form.Group>

				<Form.Group className="mb-3 fw-bold" id="variablesForm-template-group">
					<div className="row">
						<div className="col">
							<Form.Label>
								<span className="me-2">{t('dynamicContent')}</span>
								<BayTooltip
									overlay={t('dynamicContentTooltip')}
									placement="top"
								>
									<BsQuestionCircle />
								</BayTooltip>
							</Form.Label>
						</div>
						<div className="col d-flex text-end justify-content-end">
							<VariableDropdown
								baseKey="variablesForm-template"
								fieldOptions={fieldOptions}
								t={t}
								onSelect={handleVariableInsert}
							/>
						</div>
					</div>

					<Form.Control
						as="textarea"
						id="variablesForm-template"
						name={selectedElementObject.id}
						rows={5}
						value={formFields.text}
						onChange={(elm) => handleChange(elm.target, 'text')}
					/>
				</Form.Group>
			</div>
		</div>
	);
};

export const Options = ({
	store,
	templateState,
	actingAsState,
	globalDispatch,
	setTemplateState,
	previewerComponent: Previewer,
	viewOptionsComponent: ViewOptions,
	getAccess,
	templates,
	showToast = () => {},
	t,

	// Feature flags — computed by the consuming app and passed down
	isSocialMediaCaptionsEnabled = false,
}) => {
	const [showSettingsDrawer, setShowSettingsDrawer] = useState({
		show: false,
		type: '',
		title: '',
	});
	const [top, setTop] = useState(false);
	const [showPreview, setShowPreview] = useState(false);
	const [showHistory, setShowHistory] = useState(false);
	const [showJSON, setShowJSON] = useState(false);
	const [templateJSON, setTemplateJSON] = useState(templateState);

	const [layerIdUpdating, setLayerIdUpdating] = useState(null);
	const [showSocialMediaCaptionDrawer, setShowSocialMediaCaptionDrawer] =
		useState(false);
	const [isSavingCaption, setIsSavingCaption] = useState(false);

	const [formFields, setFormFields] = useState({});
	const [elementValue, setElementValue] = useState('');
	// null so the mount run of the selection effect seeds formFields for an element that is already selected
	const [selectedElementObject, setSelectedElementObject] = useState(null);

	const elementPageIndex = useRef();
	const elementChildIndex = useRef();

	const isSocialTemplate = isSocialPostTemplate(templateState);

	const isGlobalAdmin = getAccess()?.isGlobalRole && isSocialMediaCaptionsEnabled;

	const closeFunc = () => {
		setShowSettingsDrawer((prevState) => ({ ...prevState, show: false }));
		setShowSocialMediaCaptionDrawer(false);
	};

	useEffect(() => {
		setTemplateState(templateJSON);
	}, [templateJSON]);

	useEffect(() => {
		const templateData = cloneDeep(templateState);
		delete templateData.user;
		delete templateData.returnPath;
		delete templateData.dtIns;

		setTemplateJSON(templateData);
	}, [templateState]);

	useEffect(() => {
		const canvasArea = document.getElementsByClassName('konvajs-content')[0];
		const sidePanel = document.getElementsByClassName('polotno-side-panel')[0];

		window.addEventListener('scroll', () => handleOffCanvasPosition());

		canvasArea?.addEventListener('click', (e) =>
			handleWorkspaceClick(e.target, closeFunc),
		);
		sidePanel?.addEventListener('click', (e) =>
			handleWorkspaceClick(e.target, closeFunc),
		);
	}, []);

	useEffect(() => {
		const element = store.selectedElements[0];

		if (store.selectedElements.length === 0) {
			setShowSettingsDrawer((prevState) => ({ ...prevState, show: false }));
			setFormFields({});
			setSelectedElementObject(null);
			setElementValue('');
		} else if (
			element &&
			element.id &&
			element.id !== selectedElementObject?.id
		) {
			setSelectedElementObject(element);
			setElementValue(element.text ?? '');

			elementPageIndex.current = store.pages.indexOf(store.activePage);
			elementChildIndex.current = store.activePage
				.toJSON()
				.children.findIndex((e) => e.id === element.id);

			setFormFields({
				layerId: element.id,
				layerName: element.name,
				layerHeight: element.height,
				layerWidth: element.width,
				layerXcoord: element.x,
				layerYcoord: element.y,
				disabled: element?.type === 'group',
				src: templateState?.etc?.directives?.[element.id]?.src || '',
				text: templateState?.etc?.directives?.[element.id]?.text || '',
				color: templateState?.etc?.directives?.[element.id]?.color || '',
				format:
					templateState?.etc?.directives?.[element.id]?.format || 'string',
				maxLen: templateState?.etc?.directives?.[element.id]?.maxLen || 0,
				isSelectable: element.selectable,
				isDraggable: element.draggable,
				isResizable: element.resizable,
				isRemovable: element.removable,
				isContentEditable: element.contentEditable,
				isStyleEditable: element.styleEditable,
				alwaysOnTop: element.alwaysOnTop,
				showInExport: element.showInExport,
			});
		}
	}, [store.selectedElements]);

	const handleShowOptionDrawer = (drawerOptionType) => {
		handleOffCanvasPosition();

		if (drawerOptionType === 'socialMediaCaptions') {
			setShowSettingsDrawer((prevState) => ({ ...prevState, show: false }));
			setShowSocialMediaCaptionDrawer(true);
			return;
		}

		setShowSocialMediaCaptionDrawer(false);

		setShowSettingsDrawer({
			show: true,
			type: drawerOptionType,
			title: drawerOptionType ? t(drawerOptionType) : '',
		});
	};

	const handleSave = async ({
		showLinkPost,
		urlToSave,
		captionPlainText,
		linkTitlePlainText,
		linkDescriptionPlainText,
		currentEtc,
	}) => {
		if (isSavingCaption) return false;

		if (showLinkPost) {
			const urlRegex = /^https?:\/\/\S+\.\S+/;
			if (!urlRegex.test(urlToSave)) {
				showToast({
					variant: 'danger',
					text: t('invalidUrl'),
				});
				return false;
			}
		}

		const nextEtc = {
			...currentEtc,
			caption: captionPlainText,
			linkTitle: showLinkPost ? linkTitlePlainText : '',
			linkDescription: showLinkPost ? linkDescriptionPlainText : '',
			linkUrl: showLinkPost ? urlToSave : '',
		};

		setIsSavingCaption(true);

		const updatedTemplate = {
			etc: nextEtc,
		};

		try {
			const response = await templates.update(
				templateState._id,
				updatedTemplate,
			);

			if (response) {
				showToast({
					variant: 'success',
					text: t('captionSaved'),
				});
				globalDispatch(setTemplateState({ ...templateState, etc: nextEtc }));

				if (hasListingOverlayFlag(templateState)) {
					try {
						const overlayPreview = buildListingOverlayPreviewsFromRasters(
							response?.rasters ?? templateState?.rasters,
						);
						await templates.syncListingOverlayDefault({
							template_id: response._id ?? templateState._id,
							preview: Object.keys(overlayPreview).length ? overlayPreview : null,
							caption: nextEtc.caption ?? null,
							link_title: nextEtc.linkTitle ?? null,
							link_description: nextEtc.linkDescription ?? null,
						});
					} catch (syncErr) {
						console.warn(
							'Failed to sync listing overlay default after caption save:',
							syncErr,
						);
					}
				}

				return true;
			}

			showToast({
				variant: 'danger',
				text: t('errorCaptionSaved'),
			});
			return false;
		} catch (e) {
			showToast({
				variant: 'danger',
				text: t('errorCaptionSaved'),
			});
			return false;
		} finally {
			setIsSavingCaption(false);
		}
	};

	const handleOffCanvasPosition = () => {
		const elm = document.getElementsByClassName(
			'polotno-workspace-container',
		)[0];

		if (elm) {
			const rect = elm.getBoundingClientRect();

			setTop(rect.top);
		}
	};

	const handleWorkspaceClick = (targetEle, closeFunc) => {
		const selectedElementType = store.selectedElements[0]?.type;

		if (selectedElementType === 'group') {
			closeFunc();
		}
	};

	const handleChange = async (valueObject, type) => {
		const state = cloneDeep(templateState);

		if (!valueObject && type !== 'maxLen') {
			valueObject = { value: '' };
		} else if (type === 'maxLen') {
			// shortenText treats only numeric 0 as unlimited; the input yields a string
			valueObject = { value: Number(valueObject.currentTarget.value) };
		}

		const fieldValue = valueObject?.value;

		if (!state.etc) {
			state.etc = {};
		}

		if (!state.etc.directives) {
			state.etc.directives = {};
		}

		if (!state.etc.directives[selectedElementObject.id]) {
			state.etc.directives[selectedElementObject.id] = {};
		}

		state.etc.directives[selectedElementObject.id][type] = fieldValue;

		//we only allow maxLen on Plain Text
		const clearsMaxLen = type === 'format' && fieldValue !== 'string';

		if (clearsMaxLen) {
			state.etc.directives[selectedElementObject.id]['maxLen'] = 0;
		}

		setFormFields((currentState) => ({
			...currentState,
			[type]: fieldValue,
			...(clearsMaxLen ? { maxLen: 0 } : {}),
		}));

		globalDispatch(setTemplateState(state));
	};

	const handleLayerNameChange = (value) => {
		const element = store.selectedElements[0];

		if (element) {
			element.set({ name: value });
			setFormFields((currentState) => ({ ...currentState, layerName: value }));
		}
	};

	const handleLayerIdUpdate = (layerId, value) => {
		const state = cloneDeep(templateState);
		const elementId =
			state.json.pages[elementPageIndex.current].children[
				elementChildIndex.current
			].id;

		state.json.pages[elementPageIndex.current].children[
			elementChildIndex.current
		].id = value;

		let nextDirectives = { ...state?.etc?.directives };

		if (elementId && nextDirectives[elementId]) {
			const directive = nextDirectives[elementId];
			delete nextDirectives[elementId];

			nextDirectives = { ...nextDirectives, [value]: directive };
		}

		setFormFields((currentState) => ({ ...currentState, layerId: value }));

		globalDispatch(
			setTemplateState({
				...templateState,
				json: state.json,
				etc: {
					...templateState.etc,
					directives: nextDirectives,
				},
			}),
		);

		store.loadJSON(state.json);
		store.selectElements([value]);
		setLayerIdUpdating(null);
	};

	const handleObjectSettingsChange = (
		settingType,
		inputValue,
		positioning = false,
	) => {
		const element = store.selectedElements[0];
		let formType = '';

		switch (settingType) {
			case 'selectable':
				formType = 'isSelectable';
				break;
			case 'draggable':
				formType = 'isDraggable';
				break;
			case 'resizable':
				formType = 'isResizable';
				break;
			case 'removable':
				formType = 'isRemovable';
				break;
			case 'contentEditable':
				formType = 'isContentEditable';
				break;
			case 'styleEditable':
				formType = 'isStyleEditable';
				break;
			case 'alwaysOnTop':
				formType = 'alwaysOnTop';
				break;
			case 'showInExport':
				formType = 'showInExport';
				break;
			default:
				break;
		}

		if (positioning) {
			let setting = null;
			const value = Number(inputValue.currentTarget.value);

			switch (settingType) {
				case 'layerHeight':
					setting = 'height';
					break;
				case 'layerWidth':
					setting = 'width';
					break;
				case 'layerXcoord':
					setting = 'x';
					break;
				case 'layerYcoord':
					setting = 'y';
					break;
				default:
					break;
			}

			if (!setting) {
				return;
			}

			formType = settingType;
			inputValue = value;

			element.set({
				[setting]: value,
			});
		} else {
			element.set({
				[settingType]: inputValue,
			});
		}

		setSelectedElementObject(element);
		setFormFields((prevState) => ({ ...prevState, [formType]: inputValue }));
	};

	const handleVariableInsert = (variable) => {
		const elm = document.getElementById('variablesForm-template');

		//make sure it is in focus
		elm.focus();

		//it the element is blank then set the value to the variables
		if (elm.value === '') {
			elm.value = variable;
		} else {
			// ...if not then find out where the cursor is so we can insert the variable where the cursor is
			const cursorPosition = elm.selectionStart || 0;
			const textBeforeCursorPosition = elm.value.substring(0, cursorPosition);
			const textAfterCursorPosition = elm.value.substring(
				cursorPosition,
				elm.value.length,
			);

			elm.value = textBeforeCursorPosition + variable + textAfterCursorPosition;
		}

		handleChange(elm, 'text');
	};

	const fieldOptions = (field, source = dataFields) => {
		const options = [];
		const userAccess = getAccess();

		const hasAccess = (fieldData) => {
			if (!fieldData.accessLevel) return true;

			switch (fieldData.accessLevel) {
				case 'globalAdmin':
					return userAccess?.isGlobalRole;
				case 'admin':
					return userAccess?.isAdmin || userAccess?.isGlobalRole;
				default:
					return true;
			}
		};

		switch (field) {
			case 'listing':
				for (const field in source) {
					if (
						field.startsWith('listing.') &&
						!field.startsWith('listing.image_data') &&
						hasAccess(source[field])
					) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}
				break;

			case 'listingImage':
				for (const field in source) {
					if (field.startsWith('listing.image_data')) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}

				break;

			case 'user':
				for (const field in source) {
					if (
						field.startsWith('user.') &&
						!field.startsWith('user.image') &&
						!field.startsWith('user.logo') &&
						!field.startsWith('user.brand')
					) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}

				break;

			case 'userImage':
				for (const field in source) {
					if (field.startsWith('user.image') || field.startsWith('user.logo')) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}

				break;

			case 'userBrand':
				for (const field in source) {
					if (field.startsWith('user.brand')) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}

				break;

			case 'dateTime':
				for (const field in source) {
					if (field.startsWith('current_date.') && hasAccess(source[field])) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}
				break;

			case 'contentAutomation':
				for (const field in source) {
					if (
						field.startsWith('content_locations.') &&
						hasAccess(source[field])
					) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}
				break;

			case 'altosData':
				for (const field in source) {
					if (field.startsWith('altos.') && hasAccess(source[field])) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}
				break;

			case 'format':
				options.push({ value: 'number', label: 'Number' });
				options.push({ value: 'decimal', label: 'Decimal' });
				options.push({ value: 'dollar', label: 'Dollar' });
				options.push({ value: 'dollarCents', label: 'Dollar & Cents' });
				options.push({ value: 'phoneNumber', label: 'Phone Number' });
				options.push({ value: 'uppercase', label: 'Uppercase' });
				options.push({ value: 'lowercase', label: 'Lowercase' });
				options.push({ value: 'titlecase', label: 'Titlecase' });

				break;

			default:
				for (const field in source) {
					if (!field.startsWith('listing.') && !field.startsWith('user.')) {
						options.push({
							value: `{{${field}}}`,
							label: `${source[field].label}`,
						});
					}
				}

				break;
		}

		return options.slice().sort((a, b) =>
			a.label.localeCompare(b.label, undefined, {
				numeric: true,
				sensitivity: 'base',
			}),
		);
	};

	const displayDate = (date) => {
		return dayjs(date).format('MM/DD/YYYY [at] hh:mm:ss A');
	};

	const FooterElement = ({ closeDrawer }) => {
		return (
			<div className="border-top p-3 px-4">
				<div className="d-flex align-items-center justify-content-end">
					<Form.Group className="form-item mb-3">
						<Button
							disabled={false}
							variant="primary"
							onClick={() => closeDrawer()}
						>
							{t('done')}
						</Button>
					</Form.Group>
				</div>
			</div>
		);
	};

	// console.log('templateState', templateState);

	return (
		<>
			<div className="d-flex align-items-center">
				<Tooltip content={t('previewTemplate')} placement="bottom">
					<button
						className="bp5-button bp5-minimal d-flex align-items-center"
						tabIndex={-1}
						type="button"
						onClick={() => setShowPreview(true)}
					>
						<span className="bp5-icon">
							<BsEye />
						</span>
					</button>
				</Tooltip>

				<div className="bp5-divider bay-polotno-toolbar-divider" />

				<Tooltip content={t('templateInfo')} placement="bottom">
					<button
						className="bp5-button bp5-minimal d-flex align-items-center"
						tabIndex={-1}
						type="button"
						onClick={() => handleShowOptionDrawer('templateInfo')}
					>
						<span className="bp5-icon">
							<BsInfoCircle />
						</span>
					</button>
				</Tooltip>

				<div className="bp5-divider bay-polotno-toolbar-divider" />

				<Dropdown align="start">
					<Dropdown.Toggle
						as="span"
						bsPrefix="span"
						className="cursor-pointer d-flex align-items-center"
						id="settings-dropdown"
					>
						<span> {t('setting')} </span>
						<span className="ms-2">
							<BsFillCaretDownFill />
						</span>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{isSocialTemplate && isGlobalAdmin ? (
							<Dropdown.Item
								as="button"
								className="d-flex"
								onClick={() => handleShowOptionDrawer('socialMediaCaptions')}
							>
								<span className="me-2">
									<BsChatRightQuote />
								</span>
								<span>{t('socialMediaCaptions')}</span>
							</Dropdown.Item>
						) : (
							''
						)}
						<Dropdown.Item
							as="button"
							className={`d-flex align-items-center ${
								formFields?.disabled && 'disabled'
							}`}
							disabled={formFields?.disabled}
							onClick={() => handleShowOptionDrawer('objectSettings')}
						>
							<span className="me-2">
								<BsGearFill />
							</span>
							<span>{t('objectSettings')}</span>
						</Dropdown.Item>
						<Dropdown.Item
							as="button"
							className={`d-flex align-items-center ${
								store.pages.length <= 0 && 'disabled'
							}`}
							disabled={store.pages.length <= 0}
							onClick={() => handleShowOptionDrawer('pageSettings')}
						>
							<span className="me-2">
								<BsGrid1X2Fill />
							</span>
							<span>{t('pageSettings')}</span>
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</div>

			<SocialMediaCaptionDrawer
				fieldOptions={fieldOptions}
				isSavingCaption={isSavingCaption}
				show={showSocialMediaCaptionDrawer && isSocialTemplate && isGlobalAdmin}
				t={t}
				templateState={templateState}
				top={top}
				onHide={() => setShowSocialMediaCaptionDrawer(false)}
				onSave={handleSave}
			/>

			<Offcanvas
				backdrop={false}
				className="text-dark"
				container={
					document.getElementsByClassName('polotno-workspace-container')[0]
				}
				id="options_drawer"
				placement="end"
				scroll={true}
				show={showSettingsDrawer.show}
				style={{
					top,
					'--bs-offcanvas-padding-x': '1.5rem',
					'--bs-offcanvas-width': '500px',
					overflowX: 'hidden',
				}}
				onHide={() =>
					setShowSettingsDrawer((prevState) => ({ ...prevState, show: false }))
				}
			>
				<Offcanvas.Header closeButton className="border-bottom p-3 px-4">
					<div className="offcanvas-title h3">{showSettingsDrawer.title}</div>
				</Offcanvas.Header>

				{showSettingsDrawer.type === 'objectSettings' && (
					<Offcanvas.Body className="overflow-x-hidden">
						{selectedElementObject ? (
							<Form
								id="variablesForm"
								onSubmit={(e) => {
									e.preventDefault();
									return false;
								}}
							>
								{store.role === 'admin' && actingAsState.isGlobalRole && (
									<>
										<div className="h3 my-3">
											<span className="me-2">{t('layer')}</span>
											<BayTooltip
												id="layerTooltip"
												overlay={t('layerTooltip')}
												placement="top"
											>
												<BsQuestionCircle />
											</BayTooltip>
										</div>
										<div className="row ms-2 gy-3 mb-6">
											{selectedElementObject?.type !== 'group' && (
												<div className="col-12">
													<Form.Group id="variablesForm-layer_id">
														<Form.Label>{t('layerId')}</Form.Label>

														{layerIdUpdating?.show && (
															<InputGroup>
																<Form.Control
																	autoComplete="off"
																	id="variablesForm-layer_id"
																	name="layerId"
																	type="text"
																	value={layerIdUpdating.value}
																	onChange={(e) =>
																		setLayerIdUpdating({
																			show: true,
																			value: e.currentTarget.value,
																		})
																	}
																/>
																<Button
																	variant="success"
																	onClick={() =>
																		handleLayerIdUpdate(
																			formFields.layerId,
																			layerIdUpdating.value,
																		)
																	}
																>
																	<BsCheck size={21} />
																</Button>
																<Button
																	variant="secondary"
																	onClick={() => setLayerIdUpdating(null)}
																>
																	<BsX size={21} />
																</Button>
															</InputGroup>
														)}

														{!layerIdUpdating && (
															<InputGroup>
																<Form.Control
																	autoComplete="off"
																	disabled={true}
																	id="variablesForm-layer_id"
																	name="layerId"
																	type="text"
																	value={formFields.layerId}
																/>
																<Button
																	variant="secondary"
																	onClick={() =>
																		setLayerIdUpdating({
																			show: true,
																			value: formFields.layerId,
																		})
																	}
																>
																	<BsPencil size={14} />
																</Button>
															</InputGroup>
														)}
													</Form.Group>
												</div>
											)}
											<div className="col-12">
												<Form.Group id="variablesForm-layer_name">
													<Form.Label>{t('layerName')}</Form.Label>
													<Form.Control
														autoComplete="off"
														id="variablesForm-layer_name"
														name="layerName"
														type="text"
														value={formFields.layerName}
														onChange={(e) =>
															handleLayerNameChange(e.currentTarget.value)
														}
													/>
												</Form.Group>
											</div>
										</div>
									</>
								)}

								{selectedElementObject &&
								selectedElementObject?.type !== 'group' ? (
									<>
										<div className="h3 my-3">
											<span className="me-2">{t('dimensions')}</span>
											<BayTooltip
												id="dimensionTooltip"
												overlay={t('dimensionTooltip')}
												placement="top"
											>
												<BsQuestionCircle />
											</BayTooltip>
										</div>
										<div className="row ms-2 gy-3">
											<div className="col-6">
												<Form.Group id="variablesForm-layer_width">
													<Form.Label>Width</Form.Label>
													<Form.Control
														autoComplete="off"
														id="variablesForm-layer_width"
														name="layerWidth"
														step={1}
														type="number"
														value={formFields.layerWidth?.toFixed(4)}
														onChange={(elm) =>
															handleObjectSettingsChange(
																'layerWidth',
																elm,
																true,
															)
														}
													/>
												</Form.Group>
											</div>
											<div className="col-6">
												<Form.Group id="variablesForm-layer_height">
													<Form.Label>Height</Form.Label>
													<Form.Control
														autoComplete="off"
														id="variablesForm-layer_height"
														name="layerHeight"
														step={1}
														type="number"
														value={formFields.layerHeight?.toFixed(4)}
														onChange={(elm) =>
															handleObjectSettingsChange(
																'layerHeight',
																elm,
																true,
															)
														}
													/>
												</Form.Group>
											</div>
										</div>
										<div className="h3 my-3 mt-6">
											<span className="me-2">{t('position')}</span>
											<BayTooltip
												id="positionTooltip"
												overlay={t('positionTooltip')}
												placement="top"
											>
												<BsQuestionCircle />
											</BayTooltip>
										</div>
										<div className="row ms-2 gy-3 mb-6">
											<div className="col-6">
												<Form.Group id="variablesForm-layer_xcoord">
													<Form.Label>X</Form.Label>
													<Form.Control
														autoComplete="off"
														id="variablesForm-layer_xcoord"
														name="layerXcoord"
														type="number"
														value={formFields.layerXcoord?.toFixed(4)}
														onChange={(elm) =>
															handleObjectSettingsChange(
																'layerXcoord',
																elm,
																true,
															)
														}
													/>
												</Form.Group>
											</div>
											<div className="col-6">
												<Form.Group id="variablesForm-layer_Ycoord">
													<Form.Label>Y</Form.Label>
													<Form.Control
														autoComplete="off"
														id="variablesForm-layer_Ycoord"
														name="layerYcoord"
														type="number"
														value={formFields.layerYcoord?.toFixed(4)}
														onChange={(elm) =>
															handleObjectSettingsChange(
																'layerYcoord',
																elm,
																true,
															)
														}
													/>
												</Form.Group>
											</div>
										</div>
									</>
								) : (
									<div className="text-dark mt-3 mb-6">
										{t('groupElementSelected')}
									</div>
								)}

								{selectedElementObject &&
									selectedElementObject.type !== 'group' && (
										<div className="h3 my-4">
											<span className="me-2">{t('dynamicContent')}</span>
											<BayTooltip
												id="dynamicContentTooltip"
												overlay={t('dynamicContentTooltip')}
												placement="top"
											>
												<BsQuestionCircle />
											</BayTooltip>
										</div>
									)}

								{selectedElementObject &&
									(selectedElementObject.type === 'svg' ||
										selectedElementObject.type === 'figure' ||
										selectedElementObject.type === 'line') && (
										<div className="row ms-2">
											<div className="col mb-3">
												<Form.Group
													className="mb-3"
													id="variablesForm-image-group"
												>
													<Form.Label>{t('brandColors')}</Form.Label>
													<BaySelect
														controlledValue={fieldOptions('userBrand').find(
															(option) => option.value === formFields.color,
														)}
														id="variablesForm-color"
														isClearable={false}
														optionsArray={[
															{ value: '', label: 'Current Color' },
															...fieldOptions('userBrand').map(
																(option) => option,
															),
														]}
														onChangeFunc={(value) =>
															handleChange(value, 'color')
														}
													/>
												</Form.Group>
											</div>
										</div>
									)}

								{selectedElementObject &&
									selectedElementObject.type === 'image' && (
										<div className="row ms-2">
											<div className="col mb-3">
												<Form.Group
													className="mb-3"
													id="variablesForm-image-group"
												>
													<Form.Label>{t('imageSource')}</Form.Label>
													<BaySelect
														controlledValue={
															[
																{ value: '', label: t('currentImage') },
																...fieldOptions('userImage'),
																...fieldOptions('listingImage'),
															].find(
																(option) => option.value === formFields.src,
															) ||
															(formFields.src
																? { value: formFields.src, label: t('currentImage') }
																: null)
														}
														id="variablesForm-src"
														isClearable={false}
														optionsArray={[
															{ value: '', label: t('currentImage') },
															{
																label: 'User Data',
																options: fieldOptions('userImage')
																	.map((option) => option)
																	.sort(
																		(a, b) =>
																			a.label.toLowerCase() <
																			b.label.toLowerCase(),
																	),
															},
															{
																label: 'Listing Data',
																options: fieldOptions('listingImage')
																	.map((option) => option)
																	.sort(
																		(a, b) =>
																			a.label.toLowerCase() <
																			b.label.toLowerCase(),
																	),
															},
														]}
														onChangeFunc={(value) => handleChange(value, 'src')}
													/>
												</Form.Group>
											</div>
										</div>
									)}

								{selectedElementObject &&
									selectedElementObject.type === 'text' && (
										<TextElementForm
											elementValue={elementValue}
											fieldOptions={fieldOptions}
											formFields={formFields}
											handleChange={handleChange}
											handleObjectSettingsChange={handleObjectSettingsChange}
											handleVariableInsert={handleVariableInsert}
											selectedElementObject={selectedElementObject}
											t={t}
										/>
									)}

								{store.role === 'admin' && (
									<>
										<div className="h3">
											<span className="me-2">{t('userPermissions')}</span>
											<BayTooltip
												id="userPermissionsTooltip"
												overlay={t('userPermissionsTooltip')}
												placement="top"
											>
												<BsQuestionCircle />
											</BayTooltip>
										</div>
										<div className="row my-3 gy-3 ms-1">
											<div className="col-12">
												<Form.Label
													className="cursor-pointer"
													htmlFor="grid_switch"
												>
													{t('selectable')}
												</Form.Label>
												<Form.Check
													checked={formFields.isSelectable}
													id="selectable_switch"
													label={`${
														formFields.isSelectable
															? t('allowed')
															: t('notAllowed')
													}`}
													type="switch"
													onChange={(val) =>
														handleObjectSettingsChange(
															'selectable',
															val.target.checked,
														)
													}
												/>
											</div>
											{selectedElementObject?.type !== 'group' && (
												<>
													<div className="col-12">
														<Form.Label
															className="cursor-pointer"
															htmlFor="grid_switch"
														>
															{t('draggable')}
														</Form.Label>
														<Form.Check
															checked={formFields.isDraggable}
															id="draggable_switch"
															label={`${
																formFields.isDraggable
																	? t('allowed')
																	: t('notAllowed')
															}`}
															type="switch"
															onChange={(val) =>
																handleObjectSettingsChange(
																	'draggable',
																	val.target.checked,
																)
															}
														/>
													</div>
													<div className="col-12">
														<Form.Label
															className="cursor-pointer"
															htmlFor="grid_switch"
														>
															{t('resizable')}
														</Form.Label>
														<Form.Check
															checked={formFields.isResizable}
															id="resizable_switch"
															label={`${
																formFields.isResizable
																	? t('allowed')
																	: t('notAllowed')
															}`}
															type="switch"
															onChange={(val) =>
																handleObjectSettingsChange(
																	'resizable',
																	val.target.checked,
																)
															}
														/>
													</div>
												</>
											)}
											<div className="col-12">
												<Form.Label
													className="cursor-pointer"
													htmlFor="grid_switch"
												>
													{t('removable')}
												</Form.Label>
												<Form.Check
													checked={formFields.isRemovable}
													id="removable_switch"
													label={`${
														formFields.isRemovable
															? t('allowed')
															: t('notAllowed')
													}`}
													type="switch"
													onChange={(val) =>
														handleObjectSettingsChange(
															'removable',
															val.target.checked,
														)
													}
												/>
											</div>
											{selectedElementObject?.type !== 'group' && (
												<>
													<div className="col-12">
														<Form.Label
															className="cursor-pointer"
															htmlFor="grid_switch"
														>
															{t('changeContent')}
														</Form.Label>
														<Form.Check
															checked={formFields.isContentEditable}
															id="changeContent_switch"
															label={`${
																formFields.isContentEditable
																	? t('allowed')
																	: t('notAllowed')
															}`}
															type="switch"
															onChange={(val) =>
																handleObjectSettingsChange(
																	'contentEditable',
																	val.target.checked,
																)
															}
														/>
													</div>
													<div className="col-12">
														<Form.Label
															className="cursor-pointer"
															htmlFor="grid_switch"
														>
															{t('changeStyle')}
														</Form.Label>
														<Form.Check
															checked={formFields.isStyleEditable}
															id="changeStyle_switch"
															label={`${
																formFields.isStyleEditable
																	? t('allowed')
																	: t('notAllowed')
															}`}
															type="switch"
															onChange={(val) =>
																handleObjectSettingsChange(
																	'styleEditable',
																	val.target.checked,
																)
															}
														/>
													</div>
												</>
											)}
											<div className="col-12">
												<Form.Label
													className="cursor-pointer"
													htmlFor="grid_switch"
												>
													{t('alwaysOnTopLayer')}
												</Form.Label>
												<Form.Check
													checked={formFields.alwaysOnTop}
													id="alwaysOnTop_switch"
													label={`${
														formFields.alwaysOnTop ? t('yes') : t('no')
													}`}
													type="switch"
													onChange={(val) =>
														handleObjectSettingsChange(
															'alwaysOnTop',
															val.target.checked,
														)
													}
												/>
											</div>
											<div className="col-12">
												<Form.Label
													className="cursor-pointer"
													htmlFor="grid_switch"
												>
													{t('layerIsRemovedFromExport')}
												</Form.Label>
												<Form.Check
													checked={formFields.showInExport === false}
													id="showInExport"
													label={`${
														formFields.showInExport === false
															? t('yes')
															: t('no')
													}`}
													type="switch"
													onChange={() =>
														handleObjectSettingsChange(
															'showInExport',
															!formFields.showInExport,
														)
													}
												/>
											</div>
										</div>
									</>
								)}
							</Form>
						) : (
							<div className="my-3 d-flex flex-column align-items-center">
								<span className="text-dark fw-bold">
									{t('noElementSelected')}
								</span>
								<br />
								<span className="text-dark">{t('pleaseSelectElement')}</span>
							</div>
						)}
					</Offcanvas.Body>
				)}

				{showSettingsDrawer.type === 'pageSettings' && (
					<Offcanvas.Body className="overflow-x-hidden">
						<ViewOptions store={store} />
					</Offcanvas.Body>
				)}

				{showSettingsDrawer.type === 'templateInfo' && (
					<Offcanvas.Body className="overflow-x-hidden">
						<div className="fs-5 fw-bold mb-3 pb-3 border-bottom">
							{t('details')}
						</div>

						<div className="ps-1">
							<span className="fw-bold">{t('width')}:</span> {store.width}
						</div>

						<div className="ps-1 mt-3">
							<span className="fw-bold">{t('height')}:</span> {store.height}
						</div>

						<div className="ps-1 mt-3">
							<span className="fw-bold">{t('unit')}:</span> {store.unit}
						</div>

						<div className="ps-1 mt-3">
							<span className="fw-bold">{t('countrySpecific')}:</span>{' '}
							{templateState?.etc?.cfg?.isCountrySpecific ? 'Yes' : 'No'}
						</div>

						{templateState?.etc?.cfg?.isCountrySpecific && (
							<div className="ps-1 mt-3">
								<span className="fw-bold">{t('Countries')}:</span>{' '}
								{templateState?.etc?.cfg?.order.countries.map((country, index) => {
									return (
										<BayCountryIcon
											key={index}
											className="me-1"
											country={country}
										/>
									);
								})}
							</div>
						)}

						<hr />

						<div className="fs-5 fw-bold mb-3 pb-3 border-bottom">
							{t('created')} {t('by')}
						</div>

						<div className="fw-bold ps-1">{t('name')}:</div>

						<div className="ps-1">
							{templateState.creator?.firstName
								? `${templateState.creator?.firstName} ${
										templateState.creator?.lastName ?? ''
									}`
								: 'No name to display'}
						</div>

						{/* <div className="fw-bold ps-1 mt-3">{t('email')}:</div>

						<div className="ps-1">
							{templateState.creator?.username ??
								'No username or email to display'}
						</div> */}

						<div className="fw-bold ps-1 mt-3">{t('date')}:</div>

						<div className="ps-1">
							{templateState.dtIns ? displayDate(templateState.dtIns) : ''}
							<br />
							<em className="fs-7">{dayjs().to(templateState.dtIns)}</em>
						</div>

						<hr />

						<div className="fs-5 fw-bold mb-3 pb-3 border-bottom">
							{t('owner')}
						</div>

						<div className="fw-bold ps-1">{t('name')}:</div>

						<div className="ps-1">
							{templateState.owner?.displayName ?? 'No name to display'}
						</div>

						<div className="fw-bold ps-1 mt-3">ID:</div>
						<div className="ps-1">
							{templateState.owner?._id ?? 'No customer ID to display'}
						</div>

						<hr />

						<div className="fs-5 fw-bold mb-3 pb-3 border-bottom">
							{t('tags')}
						</div>

						{templateState?.tags$Category?.length > 0 ? (
							<div className="ps-1">
								<div className="fw-bold my-3">{t('categories')}:</div>
								<BayTags
									data={templateState.tags$Category?.map((tag, index) => {
										return {
											tagName: tag.name
												? tag.name
												: typeof tag === 'string' && tag.startsWith('0:')
													? tag.substring(tag.lastIndexOf(':') + 1)
													: tag,
											id: tag._id ? tag._id : index,
										};
									})}
									removable={false}
								/>
							</div>
						) : (
							<p className="text-dark ms-2">{t('noCategories')}</p>
						)}

						<hr className="text-400" />

						{templateState?.tags$General?.length > 0 ? (
							<div className="ps-1">
								<div className="fw-bold my-3">{t('general')}:</div>
								<BayTags
									data={templateState.tags$General?.map((tag, index) => {
										return {
											tagName: `${tag?.tagSet ? `${tag?.tagSet?.name}:` : typeof tag === 'string' && tag.startsWith('0:') ? '' : 'No Tagset Group:'}${tag.name ? tag.name : typeof tag === 'string' && tag.startsWith('0:') ? tag.substring(tag.indexOf('0:') + 2) : tag}`,
											id: tag._id ? tag._id : index,
										};
									})}
									removable={false}
								/>
							</div>
						) : (
							<p className="text-dark ms-2">{t('noTags')}</p>
						)}

						<hr />

						<div className="fs-5 fw-bold pb-3 mb-3 border-bottom d-flex align-items-center justify-content-between">
							{t('history')}{' '}
							<Button
								size="sm"
								variant="link"
								onClick={() => setShowHistory(!showHistory)}
							>
								{showHistory ? 'Hide' : 'Show'}
							</Button>
						</div>

						<Collapse in={showHistory}>
							<div className="list-group list-group-flush">
								{templateState.history.length > 0 ? (
									templateState.history
										.map((rec, index) => {
											if (rec.user) {
												return (
													<li
														key={`info-update-${index}`}
														className="px-2 list-group-item"
													>
														<div className="gy-2">
															<div className="col-12 d-flex justify-content-between align-items-start">
																<div className="me-auto">
																	<BayBadge
																		isLight
																		small
																		bg={index === 0 ? 'cyan' : 'green'}
																		text={index === 0 ? 'cyan' : 'green'}
																	>
																		{index === 0 ? t('created') : t('saved')}
																	</BayBadge>
																</div>
																<div>
																	<div className="d-flex fs-8 text-muted justify-content-end text-end">
																		{displayDate(rec.dt)}
																		<br />
																		{dayjs().to(rec.dt)}
																	</div>
																</div>
															</div>
															<div className="col-12">
																{rec.user.fullName?.length > 1
																	? rec.user.fullName
																	: `${rec.user.lastName} ${rec.user.lastName}`}
																<br />
																{rec.user.email}
															</div>
														</div>
													</li>
												);
											} else {
												return false;
											}
										})
										.reverse()
								) : (
									<li className="px-2 list-group-item">{t('noHistory')}</li>
								)}
							</div>
						</Collapse>

						{actingAsState.isGlobalRole && (
							<>
								<div className="fs-5 fw-bold pb-3 mb-3 border-bottom d-flex align-items-center justify-content-between">
									{t('JSON')}{' '}
									<Button
										size="sm"
										variant="link"
										onClick={() => setShowJSON(!showJSON)}
									>
										{showJSON ? 'Hide' : 'Show'}
									</Button>
								</div>

								<Collapse in={showJSON}>
									<div>
										<JsonViewer
											data={templateJSON}
											setTemplateJSON={setTemplateJSON}
											store={store}
										/>
									</div>
								</Collapse>
							</>
						)}
					</Offcanvas.Body>
				)}

				<FooterElement closeDrawer={closeFunc} />
			</Offcanvas>

			<Modal
				fullscreen
				show={showPreview}
				size="lg"
				onHide={() => setShowPreview(false)}
			>
				<Modal.Header closeButton>
					<Modal.Title>{t('preview')}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Previewer
						altos={sampleData.altos}
						listing={sampleData.listing}
						template={templateState}
						user={{ ...actingAsState, ...actingAsState?.brand }}
					/>
				</Modal.Body>

				<Modal.Footer className="d-flex justify-content-end">
					<Button
						className="rounded-1"
						size="lg"
						variant="primary"
						onClick={() => setShowPreview()}
					>
						{t('close')}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default Options;
